module.exports = __webpack_public_path__ + "img/business-man.81cdaab.png";